import {mapGetters} from 'vuex';
import {AppService} from '../service/app.service';
export const PosMixins = {
  data() {
    return {
      authPos :  AppService.originalState('auth','authPos'),
      authUser :  AppService.originalState('auth','authUser')
    };
  },

  methods: {},

  computed: {
    /**
     * 1 - systemadmin
     * 2 - si
     * 3 - principal
     * 4 - manning
     * 5 - crew
     */
    isSuperIntendent() {
      return this.authPos.id === 2
    },

    isSystemAdmin(){
      return this.authPos.id === 1
    },

    isPrincipal(){
      return this.authPos.id === 3
    },

    isManning(){
      return this.authPos.id === 4
    },

    isCrew() {
      return this.authPos.id === 5;
    },

    isKlineUser(){
      return [617,618].includes(this.authUser.id)
    }
  },
};

export default {PosMixins};
